import { StrictMode, Component, type ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MotionConfig } from 'framer-motion'
import { AppDataProvider } from './context/AppDataContext';
import App from './App.tsx'
import './index.css'

class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean, error: Error | null }> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-background text-foreground p-4 text-center">
            <h1 className="text-2xl font-bold mb-4 text-destructive">משהו השתבש...</h1>
            <p className="text-muted-foreground mb-4">האפליקציה נתקלה בשגיאה לא צפויה.</p>
            <pre className="bg-muted p-4 rounded text-left text-xs mb-4 overflow-auto max-w-full">
                {this.state.error?.toString()}
            </pre>
            <button 
                onClick={() => window.location.reload()}
                className="bg-primary px-6 py-2 rounded-xl font-bold hover:bg-primary/80 transition-colors"
            >
                רענן עמוד
            </button>
        </div>
      );
    }

    return this.props.children;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <MotionConfig reducedMotion="user">
          <AppDataProvider>
            <App />
          </AppDataProvider>
        </MotionConfig>
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>,
)
